import React from 'react';
import BlastResults from '../blast_sms/BlastResults';

function SmsNewsletterResults() {
    return (
        <BlastResults
            listPath="/newsletter/sms"
            listLabel="Past SMS Newsletter"
            channelLabel="SMS Newsletter"
            icon="bi-chat-text"
        />
    );
}

export default SmsNewsletterResults;
